/* Gild & Ink — shared "Order a sample" dialog wiring.
   Any [data-gi-sample-trigger] button on the page opens the single
   [data-gi-sample-dialog] and populates it from that button's own
   data-sample-* attributes. See snippets/gi-sample-dialog.liquid,
   snippets/gi-range-card.liquid, snippets/gi-piece-card.liquid. */
(function () {
  var dialog = document.querySelector('[data-gi-sample-dialog]');
  var triggers = document.querySelectorAll('[data-gi-sample-trigger]');
  if (!dialog || !triggers.length) return;

  var selection = dialog.querySelector('[data-gi-sample-selection]');
  var description = dialog.querySelector('[data-gi-sample-description]');
  var variantInput = dialog.querySelector('[data-gi-sample-variant]');
  var cardInput = dialog.querySelector('[data-gi-sample-card]');
  var imageInput = dialog.querySelector('[data-gi-sample-image-property]');
  var rangeInput = dialog.querySelector('[data-gi-sample-range-property]');
  var pieceInput = dialog.querySelector('[data-gi-sample-piece-property]');
  var urlInput = dialog.querySelector('[data-gi-sample-url-property]');

  triggers.forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var card = trigger.getAttribute('data-sample-card') || '';
      var piece = trigger.getAttribute('data-sample-piece') || 'Stationery card';
      var range = trigger.getAttribute('data-sample-range') || '';
      var imageUrl = trigger.getAttribute('data-sample-image') || '';
      var productUrl = trigger.getAttribute('data-sample-url') || '';

      selection.textContent = card;
      description.textContent = 'We’ll send this ' + piece.toLowerCase() + ' from the ' + range + ' range with sample wording printed.';
      variantInput.value = trigger.getAttribute('data-sample-variant');
      cardInput.value = piece + ' sample';
      imageInput.value = imageUrl;
      rangeInput.value = range;
      pieceInput.value = piece;
      urlInput.value = productUrl;

      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
    });
  });

  dialog.querySelectorAll('[data-gi-sample-close]').forEach(function (button) {
    button.addEventListener('click', function () { dialog.close(); });
  });
  dialog.addEventListener('click', function (event) {
    if (event.target === dialog) dialog.close();
  });
})();
